import { render, staticRenderFns } from "./nullCustom.vue?vue&type=template&id=710a741a&scoped=true&"
import script from "./nullCustom.vue?vue&type=script&lang=js&"
export * from "./nullCustom.vue?vue&type=script&lang=js&"
import style0 from "./nullCustom.vue?vue&type=style&index=0&id=710a741a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710a741a",
  null
  
)

export default component.exports